import { GlobalDialogService } from 'core/services/GlobalDialogService';
import { UserStore } from './user-store';
import { GlobalLoaderStore } from 'shared/components/global-loader';
import { makeObservable } from 'mobx';

export class RootStore {
   public readonly globalDialog: GlobalDialogService;
   public readonly userStore: UserStore;
   public readonly globalLoader: GlobalLoaderStore;
   constructor() {
      makeObservable(this);
      this.globalDialog = new GlobalDialogService();
      this.userStore = new UserStore(this);
      this.globalLoader = new GlobalLoaderStore();
   }
}
